import React, {Component} from 'react';
import {Spinner} from "../../Spinner";
import {HELP_LOOKER_CC, LinkToArticle} from "../../help_center/LinkToArticle";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {LOOKER_CC_CHANNEL} from "../../channels/channels";
import {ApiKeyComponent, ApiKeyTypeLookerCC} from "../ApiKey";
import { withTranslation } from 'react-i18next';

class LookerCCComponentClass extends Component {

    render() {
        const { t } = this.props;
        return (
            <div className="section-body-item -wider box">
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo width={35} height={35} channel={LOOKER_CC_CHANNEL}/>{t('looker_cc.title')}</h2>
                </header>
                {this.renderInnerComponents()}
            </div>
        )
    }

    renderNotAccessStatus() {
        const { t } = this.props;
        return <div className="form-row">
            <div className="alert alert-info">
                {t('looker_cc.not_access_message')}
            </div>
        </div>

        // return <div className="form-row">
        //     <div className="alert alert-info">
        //         El conector con Looker Studio no está incluido en tu suscripción actual.
        //     </div>
        // </div>
    }

    renderInnerComponents() {
        const { t } = this.props;
        const elements = [];
        elements.push(<div className="form-row">
            <label>{t('looker_cc.description')}&nbsp;&nbsp;➡️<LinkToArticle article={HELP_LOOKER_CC}/></label>
        </div>);

        if(this.props.loading) {
            elements.push(<div className="box-loader"><Spinner color="positive"/></div>);
            return elements;
        }

        if(!this.props.hasAccessToModule) {
            elements.push(this.renderNotAccessStatus());
            return elements;
        }

        elements.push(<ApiKeyComponent key="button" apiKey={this.props.apiKey}  keyType={ApiKeyTypeLookerCC} />)
        return elements;
    }
}

export const LookerCCComponent = withTranslation()(LookerCCComponentClass);
